import flow from 'lodash/fp/flow.js';
import values from 'lodash/values.js';
import flatMap from 'lodash/fp/flatMap.js';
import some from 'lodash/fp/some.js';

const doAnyOptionsHaveErrors = flow(
  values,
  flatMap(opt => opt.messages || []),
  some(msg => msg.messageType.toLowerCase() === 'error'),
);

export default doAnyOptionsHaveErrors;
